import gql from 'graphql-tag';

export const GET_CAMPAIGNS = gql`
  query GetCampaigns($query: CampaignsQuery!) {
    getCampaigns(query: $query) {
      total
      data {
        _id
        campaignName
        campaignType
        campaignStartDate
        campaignEndDate
        campaignAmount
        campaignStatus
        campaignPriority
        company {
          name
        }
      }
    }
  }
`;

export const GET_CAMPAIGN = gql`
  query GetCampaign($id: String!) {
    getCampaign(id: $id) {
      _id
      campaignName
      campaignType
      campaignClicks
      campaignViews
      campaignStartDate
      campaignEndDate
      campaignAmount
      campaignStatus
      campaignResource
      campaignPriority
      company {
        name
      }
    }
  }
`;

export const GET_CAMPAIGN_STATS = gql`
  query GetCampaignStats($id: MOID!) {
    getCampaignStat(id: $id) {
      byClass {
        clicks
        views
        class
      }
      byRegion {
        clicks
        views
        region
      }
      byGender {
        clicks
        views
        gender
      }
    }
  }
`;

export const GET_CAMPAIGN_DAILY_STATS = gql`
  query GetCampaignDailyStats($id: MOID!) {
    getCampaignDailyStats(id: $id) {
      data {
        clicks
        date
        views
      }
    }
  }
`;

export const CREATE_CAMPAIGN = gql`
  mutation CreateCampaign($input: CampaignsInput!) {
    createCampaign(input: $input) {
      _id
    }
  }
`;

export const GET_CAMPAIGNS_STATS = gql`
  query GetCampaignsStats {
    getCampaignsStats {
      totalCampaigns
      totalCompleted
      totalOngoing
      totalPending
    }
  }
`;
